export default __webpack_public_path__ + "static/media/loginbaner.143ce63f.png";